import {createSelector} from "reselect";
import Screens from "./screens";
import isEmpty from "lodash/isEmpty";
import CurrentRideSelectors from "../Ducks/CurrentRide/selectors";
import CurrentRequestSelectors from "../Ducks/CurrentRequest/selectors";
import AppSelectors from "../Ducks/App/selectors";
import {RideStatus} from "../../Utils/AppUtils";


const shouldShowDropoffMarker = createSelector(
    CurrentRideSelectors.getDropoff,
    (dropoff) => {
        return !!(dropoff && !isEmpty(dropoff));
    },
);

const shouldShowPickupMarker = createSelector(
    CurrentRideSelectors.getPickup,
    CurrentRideSelectors.isRideBoarded,

    (pickup, rideBoarded) => {
        return !!(pickup && !isEmpty(pickup) && !rideBoarded);
    },
);

const shouldShowPickupMarkerSpot = createSelector(
    shouldShowPickupMarker,
    Screens.shouldShowProposal,

    (showPickupMarker, showingProposal) => {
        return !!(showPickupMarker && showingProposal);
    },
);

const shouldShowPickupMarkerETA = createSelector(
    shouldShowPickupMarker,
    CurrentRideSelectors.isRideAccepted,

    (showPickupMarker, rideAccepted) => {
        return !!(showPickupMarker && rideAccepted);
    },
);

const shouldShowDestMarker = createSelector(
    CurrentRequestSelectors.isDestSelected,
    CurrentRideSelectors.getRideStatus,

    (destSelected, rideStatus) => {
        return !!(destSelected && rideStatus < RideStatus.ACCEPTED);
    },
);
const shouldShowOriginMarker = createSelector(
    CurrentRequestSelectors.isOriginSelected,
    CurrentRideSelectors.getRideStatus,

    (originSelected, rideStatus) => {
        return !!(originSelected && rideStatus < RideStatus.ACCEPTED);
    },
);

const shouldShowPickupMarkerSimple = createSelector(
    shouldShowPickupMarker,
    CurrentRideSelectors.isRideAccepted,
    Screens.shouldShowProposal,

    (showPickupMarker, rideAccepted, showingProposal) => {
        return !!(showPickupMarker && !rideAccepted && !showingProposal);
    },
);
const shouldShowRiderMarker = createSelector(
    CurrentRideSelectors.currentRideSelector,
    AppSelectors.getRiderLocation,
    CurrentRideSelectors.getRideStatus,

    (currentRide, riderLocation, rideStatus) => {
        return !!(riderLocation && !isEmpty(riderLocation) && rideStatus <= RideStatus.ACCEPTED);
    },
);

const shouldShowVanMarker = createSelector(
    CurrentRideSelectors.currentRideSelector,

    (currentRide) => {
        return currentRide && !isEmpty(currentRide) && currentRide.vehicle_location && !isEmpty(currentRide.vehicle_location);
    },
);

export default {
    shouldShowPickupMarker,
    shouldShowPickupMarkerSpot,
    shouldShowPickupMarkerETA,
    shouldShowDropoffMarker,
    shouldShowDestMarker,
    shouldShowOriginMarker,
    shouldShowPickupMarkerSimple,
    shouldShowRiderMarker,
    shouldShowVanMarker,
};


// WEBPACK FOOTER //
// ./src/Store/Views/markers.js